const Footer = () => {

    return (
        <footer>
            <p>Copyright <span className="copyright">&copy;</span> Nicolas Persivale - 2022 </p> 
        </footer>
    )
}

export default Footer;